export default __webpack_public_path__ + "static/media/news1.53ece731.webp";